import React from "react";
import { Button, Avatar } from "antd";
import {
  CalendarOutlined,
  CheckCircleOutlined,
  UserOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { formatDateByLocale } from "../../utils/dateFormat";
import { PreviewContainer } from "./style";

export default function ChallengePreview({
  challengeData = {},
  buttonText = "Open in the App to enroll",
  buttonLoading = false,
  onOpenInApp = () => {},
  onClickCoach = () => {},
}) {
  const {
    banner,
    title,
    scheduledAt,
    enrolledCount = 0,
    description,
    coach,
    subscriberCount = 0,
  } = challengeData;

  return (
    <PreviewContainer>
      <div className="preview-top">
        <img src={banner} alt="banner_image" className="preview-banner" />
        <div className="preview-top-shadow">
          <div className="preview-headline">{title || "Title"}</div>
          <div className="preview-subtitle">
            by {coach?.name || "Coach Name"}
          </div>
        </div>
      </div>
      <div className="preview-content">
        <Button
          type="primary"
          block
          size="large"
          onClick={onOpenInApp}
          loading={buttonLoading}
        >
          {buttonText}
        </Button>
        <div className="preview-date-enroll">
          <div>
            <CalendarOutlined className="mr-10" />
            {formatDateByLocale(scheduledAt, "en-US").split(",")[0]}
          </div>
          <div className="preview-date-enroll-line"></div>
          <div>
            <CheckCircleOutlined className="mr-10" />
            {enrolledCount} enrolled
          </div>
        </div>
        <div className="preview-about">About</div>
        <div className="preview-about-content">{description}</div>
        <div className="preview-coach-card">
          <div className="preview-coach-header">
            <Avatar
              src={coach?.profile_image}
              icon={<UserOutlined />}
              size={64}
              onClick={onClickCoach}
            />
            <div className="preview-coach-info">
              <div className="preview-coach-name">
                {coach?.name || "Coach Name"}
              </div>
              <div className="preview-coach-subscribers">
                {subscriberCount} subscribers
              </div>
            </div>
          </div>
          {coach?.socialLink && (
            <div
              className="preview-coach-link"
              onClick={() => window.open(coach.socialLink, "_blank")}
            >
              <LinkOutlined className="link-icon" />
              <span>{coach.socialLink}</span>
            </div>
          )}
          <div className="preview-coach-description">
            {coach?.about || "No description available"}
          </div>
        </div>
      </div>
    </PreviewContainer>
  );
}
